var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('a',{staticClass:"btn btn-success btn-fill btn-squared pull-right",on:{"click":_vm.criarPDF}},[_vm._v("Exportar")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b1eba2e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Simulacoes/Relatorios/Consolidado/Simples/Pasto/Exports/ExportarPDFeXLS.vue
// module id = sIM4
// module chunks = 5